import { frontendURL } from 'dashboard/helper/URLHelper';
import PipelineKanban from './PipelineKanban.vue';
import MyTasksIndex from './MyTasksIndex.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/pipelines/:pipelineId'),
      name: 'pipeline_kanban',
      component: PipelineKanban,
      meta: { permissions: ['administrator', 'agent'], featureFlag: 'crm' },
    },
    {
      path: frontendURL('accounts/:accountId/my-tasks'),
      name: 'my_tasks',
      component: MyTasksIndex,
      meta: { permissions: ['administrator', 'agent'], featureFlag: 'crm' },
    },
  ],
};
